import {
  AlternativeOfferConfirmationJob,
} from '@dapi/sdk';

export const alternativeOfferConfirmationJobMock: AlternativeOfferConfirmationJob = {
  id: 'AY12138213',
  status: 'completed'
};

export const alternativeOfferInProgressJobMock: AlternativeOfferConfirmationJob = {
  id: 'AY12138213',
  status: 'inProgress'
};
